import * as BABYLON from 'babylonjs'
// import HScene from '@/core/HScene.js'
import Avatar from '@/core/Avatar.js'
// import { loadInstances } from '@/core/instances.js'
import HScene from '@/core/HScene.js'

import Section from '@/hobjects/Section.js'
import Surface from '@/hobjects/Surface.js'
import Generic from '@/hobjects/Generic.js'
import Activator from '@/hobjects/Activator.js'
import Land from '@/hobjects/Land.js'
import OrionTower from '@/hobjects/OrionTower.js'
import Hangar01 from '@/hobjects/Hangar01.js'
import Pavilion from '@/hobjects/Pavilion.js'
import StandFiladelfia from '@/hobjects/StandFiladelfia.js'
import StandMarsella from '@/hobjects/StandMarsella.js'
import StandAlejandria from '@/hobjects/StandAlejandria.js'
import StandBabilonia from '@/hobjects/StandBabilonia.js'
import StandMileto from '@/hobjects/StandMileto.js'
import OfficeR06SY from '@/hobjects/OfficeR06SY.js'
import OfficeR05 from '@/hobjects/OfficeR05.js'
import OfficeR06 from '@/hobjects/OfficeR06.js'
import SangYongHall from '@/hobjects/SangYongHall.js'
import SilverTotem from '@/hobjects/SilverTotem.js'
import SilverBannerPodium from '@/hobjects/SilverBannerPodium.js'

export default class Environment {
  constructor () {
    // Get the canvas DOM element
    this.canvas = document.getElementById('renderCanvas')
    // Load the 3D engine
    this.engine = new BABYLON.Engine(this.canvas, true, {preserveDrawingBuffer: true, stencil: true})
    // Create a basic BJS Scene object
    this.scene = null

    // Third person camera
    this.camera = null
    // First person camera
    this.cameraFP = null

    this.localAvatar = null
    this.remoteAvatars = []

    // this.hScene = null
  }

  // CreateScene function that creates and return the scene
  createScene () {
    // Los meshes precargados de un anterior scene no se ven en una nueva instancia de scene
    // Toca resetear los static de las clases que heredan de hObjects para que carguen a partir del nuevo scene
    // o limpiar el actual scene o manejar el scene static pero entonces solo se podría usar un solo scene en un futuro
    Section.loadRequest = false
    Section.meshes.length = []
    Surface.loadRequest = false
    Surface.meshes.length = []
    StandMarsella.loadRequest = false
    StandMarsella.meshes.length = []
    OfficeR06.loadRequest = false
    OfficeR06.meshes.length = []

    this.scene = new BABYLON.Scene(this.engine)
    window.scene = this.scene
    // Third person camera
    this.camera = new BABYLON.FollowCamera('FollowCam', new BABYLON.Vector3(0, 0, 0), this.scene)
    // First person camera
    this.cameraFP = new BABYLON.FreeCamera('FreeCamera', new BABYLON.Vector3(0, 0, 0), this.scene)

    this.localAvatar = null
    this.remoteAvatars = []

    // this.hScene = new HScene()
    // window.hScene = this.hScene

    // Labels 2D
    // var screenCanvas = new BABYLON.ScreenSpaceCanvas2D(scene, { id: 'ScreenCanvas' })

    // Collisions
    this.scene.collisionsEnabled = true
    this.scene.gravity = new BABYLON.Vector3(0, -9.81, 0)

    // Skybox
    var skybox = BABYLON.Mesh.CreateBox('skyBox', 10000.0, this.scene)
    var skyboxMaterial = new BABYLON.StandardMaterial('skyBox', this.scene)
    skyboxMaterial.backFaceCulling = false
    skyboxMaterial.reflectionTexture = new BABYLON.CubeTexture('static/textures/TropicalSunnyDay', this.scene)
    skyboxMaterial.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE
    skyboxMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0)
    skyboxMaterial.specularColor = new BABYLON.Color3(0, 0, 0)
    skyboxMaterial.disableLighting = true
    skybox.material = skyboxMaterial

    // Initialise the local player
    /* var startX = 0 + Math.round(Math.random() * (20))
    var startY = 2
    var startZ = 1480 + Math.round(Math.random() * (20))

    localAvatar = new Player(startX, startY, startZ, scene)
    */
    // localAvatar = new Avatar(-330 + (Math.random() * 20), 2, 930 + (Math.random() * 20)) // 1480
    // localAvatar = new Avatar(0 + (Math.random() * 20), 2, 900 + (Math.random() * 20)) // 1480
    this.localAvatar = new Avatar(30, 10, -825) // 1480
    this.localAvatar.setRotY(-90 * Math.PI / 4)

    this.localAvatar.getRepresentacion().actionManager = new BABYLON.ActionManager(window.scene)
    this.localAvatar.getRepresentacion().actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
      window.environment.selectFirstPersonCamera()
    }))
  }

  selectFirstPersonCamera () {
    this.cameraFP.position.x = this.localAvatar.position.x
    this.cameraFP.position.y = this.localAvatar.position.y
    this.cameraFP.position.z = this.localAvatar.position.z
    this.cameraFP.rotation.y = this.localAvatar.rotation.y

    this.cameraFP.attachControl(this.canvas)
    this.scene.activeCamera = this.cameraFP
  }

  selectThirdPersonCamera () {
    this.camera.radius = 5 // how far from the object to follow
    this.camera.heightOffset = 0.5 // how high above the object to place the camera
    this.camera.rotationOffset = 180 // the viewing angle
    this.camera.cameraAcceleration = 0.01 // how fast to move
    this.camera.maxCameraSpeed = 20 // speed limit

    this.camera.attachControl(this.canvas)
    this.scene.activeCamera = this.camera
  }

  go (dimension) {
    // Resetear scene de babylon
    console.log('Go:::')
    console.log(window.dimension + ' -> ' + dimension)

    window.hScene = new HScene()

    if (window.environment.scene) {
      window.environment.scene.dispose()
      window.environment.scene = null
    }

    window.environment.createScene()
    window.environment.selectThirdPersonCamera()

    // Espacio para que el avatar se ubique en las coordenadas de la app a cargar

    // Cargar hObjects
    window.dimension = dimension
    // loadInstances(window.hScene)
    window.hScene.fetchHApps(window.dimension)
  }
}



// WEBPACK FOOTER //
// ./src/core/Environment.js